<template>
	<section
		:class="[
		'block-wrapper', 
		componentClass, 
		colorMode
	]"
	>
		<div class="row">
			<div class="small-10 medium-8 large-6 xlarge-4 small-offset-1 medium-offset-2 large-offset-3 xlarge-offset-4 columns">
				<p class="ingress" v-html="sanitizedIntroText"></p>
			</div>
		</div>
		<div class="row key-numbers-boxes-wrapper">
			<div class="small-12 medium-10 large-8 xlarge-6 medium-offset-1 large-offset-2 xlarge-offset-3 columns">
				<div class="row small-up-2 medium-up-4">
					<div v-for="(keyNumBox, index) in data.key_numbers_boxes"
						:key="data.component_id + '-' + index"
						:class="['columns']">
						<article class="key-numbers-box">
							<img :src="keyNumBox.icon.src" :alt="keyNumBox.icon.alt" />
							<h2 v-text="keyNumBox.number"></h2>
							<p v-text="keyNumBox.text"></p>
						</article>
					</div>
				</div>
			</div>
		</div>
		<div v-if="data.link" class="small-12 medium-10 large-8 xlarge-6 medium-offset-1 large-offset-2 xlarge-offset-3 columns text-center">
			<router-link v-bind:to="{path: data.link.url}" v-text="data.link.title" class="wysiwyg-link white"></router-link>
		</div>
	</section>
</template>


<script>
import DOMPurify from 'dompurify';
import BaseBlock from './Base'
export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'blue',
			componentClass: 'key-numbers',
		}
	},
	computed: {
		sanitizedIntroText() {
			return DOMPurify.sanitize(this.data.text)
		}
	}
}
</script>

<style lang="scss">
@import "../../styles/scss/component/homepage/key-numbers";
@import "../../styles/scss/component/wysiwyg/link";
</style>
